<template>
  <section>
    <!--工具条-->
    <el-card>
      <el-row class="flex">
        <el-select
          v-if="userInfo.uID == 12"
          v-model="SchoolName"
          placeholder="请选择所属幼儿园"
          @visible-change="onScrollData"
          @change="onChangeScrollData"
        >
          <el-option
            v-for="item in SchoolList"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="searchnames"
          placeholder="请输入姓名"
          style="width: 200px; margin-left: 20px"
        ></el-input>
        <el-input
          v-model="Phone"
          placeholder="请输入手机号"
          style="width: 200px; margin-left: 20px"
        ></el-input>
        <el-button type="primary" style="margin-left: 20px" @click="getUsers"
          >查询</el-button
        >
      </el-row>
    </el-card>
    <el-card style="margin-top: 30px">
      <el-row>
        <el-col>
          <el-button type="primary" @click="handleAdd">新增</el-button>

          <el-button type="primary" @click="dialogVisibleImport = true"
            >导入教师</el-button
          >
          <el-button type="primary" @click="dialogVisibleTeacherImport = true"
            >更新教师权限</el-button
          >

          <el-button type="primary" @click="onStudentExeal"
            >下载教师模板</el-button
          >
          <el-button type="danger" @click="DelTeacherInfo">批量删除</el-button>
          <el-button type="danger" @click="OpenResetPwd">重置密码</el-button>
        </el-col>
      </el-row>
    </el-card>
    <!--列表-->
    <el-row style="margin-top: 30px">
      <el-table
        :data="users"
        highlight-current-row
        @current-change="selectCurrentRow"
        @selection-change="selsChange"
        border
        style="width: 100%"
        :header-cell-style="{ background: '#F2F5FF', color: '#333' }"
      >
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column align="center" label="编号" type="index" width="80">
        </el-table-column>
        <el-table-column
          align="center"
          prop="TeacherName"
          label="姓名"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="LoginCode"
          label="登录账号"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column
          align="center"
          prop="Phone"
          label="手机号"
          width=""
          sortable
        >
        </el-table-column>

        <el-table-column
          align="center"
          prop="SchoolName"
          label="幼儿园名称"
          width=""
          sortable
        >
        </el-table-column>
        <el-table-column label="身份" align="center">
          <template slot-scope="scope">
            {{ scope.row.IsHeader ? "园长" : "教师" }}
          </template>
        </el-table-column>
        <el-table-column label="关联账号" align="center">
          <template slot-scope="scope">
            <el-button type="primary" @click="onClickOpen(scope.row)">{{
              scope.row.UserId == 0 ? "绑定" : "查看"
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column label="性别" width="" align="center">
          <template slot-scope="scope">
            {{ scope.row.Sex == 1 ? "男" : "女" }}
          </template>
        </el-table-column>
        <el-table-column label="负责班级" align="center">
          <template slot-scope="scope">
            <div v-for="(item, index) in scope.row.RoleClassName" :key="index">
              {{ item }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template slot-scope="scope">
            <div class="flex" style="justify-content: space-around">
              <div
                class="tui-edit"
                @click="handleEdit(scope.$index, scope.row)"
              >
                编辑
              </div>
              |

              <div
                class="tui-edit"
                @click="OpenTeacherRole(scope.$index, scope.row)"
              >
                管理权限
              </div>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </el-row>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      > -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="PageIndex"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="text-align: center;padding:20px; 0 0 0"
      >
      </el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        @submit.native.prevent
        :model="editForm"
        :rules="editFormRules"
        ref="editForm"
      >
        <el-form-item align="center" label="姓名" prop="name">
          <el-input v-model="editForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否为园长">
          <el-radio-group v-model="editForm.resource">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item align="center" label="手机号">
          <el-input v-model="editForm.Phone" auto-complete="off"></el-input>
        </el-form-item>

        <el-form-item
          label="所属幼儿园"
          prop="SchoolName"
          v-if="userInfo.uID == 12"
        >
          <el-select
            v-model="editForm.SchoolName"
            placeholder="请选择"
            @visible-change="addonScrollData"
          >
            <el-option
              v-for="item in addSchoolList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="性别">
          <el-radio-group v-model="editForm.sex">
            <el-radio class="radio" :label="1">男</el-radio>
            <el-radio class="radio" :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      width="25%"
      :close-on-click-modal="false"
    >
      <el-form
        @submit.native.prevent
        :model="addForm"
        :rules="addFormRules"
        ref="addForm"
        label-position="left"
      >
        <el-form-item align="center" label="姓名" prop="name">
          <el-input v-model="addForm.name" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否为园长">
          <el-radio-group v-model="addForm.resource">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item align="center" label="手机号">
          <el-input v-model="addForm.Phone" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item
          label="所属幼儿园"
          prop="SchoolName"
          v-if="userInfo.uID == 12"
        >
          <el-select
            v-model="addForm.SchoolName"
            placeholder="请选择"
            @visible-change="addonScrollData"
          >
            <el-option
              v-for="item in addSchoolList"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!--<el-form-item label="姓名" prop="name">-->
        <!--<el-input v-model="addForm.name" auto-complete="off"></el-input>-->
        <!--</el-form-item>-->
        <el-form-item label="性别">
          <el-radio-group v-model="addForm.sex">
            <el-radio class="radio" :label="1">男</el-radio>
            <el-radio class="radio" :label="0">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisibleresetpwd"
      width="30%"
      title="重置密码"
    >
      <el-row class="flex-items">
        <el-col class="tui-border flex-center">
          <div style="width: 100px">新密码：</div>
          <el-input v-model="newpwd" placeholder="请输入新密码"></el-input>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleresetpwd = false">取 消</el-button>
        <el-button type="primary" @click="ResetPwd">保存</el-button>
      </span>
    </el-dialog>

    <el-dialog title="教师导入" :visible.sync="dialogVisibleImport">
      <el-upload
        class="image-uploader"
        :multiple="false"
        :auto-upload="true"
        list-type="excel"
        :show-file-list="true"
        :drag="true"
        action
        :limit="1"
        :on-exceed="handleExceed"
        :before-upload="beforeUpload"
        :http-request="uploadFile"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          一次只能上传一个文件，仅限excel格式，单文件不超过5MB
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleImport = false">取消</el-button>
        <el-button type="primary" @click="ImportTeacherinfo">提交</el-button>
      </div>
    </el-dialog>
    <!-- 更新教师权限 -->
    <el-dialog title="更新教师权限" :visible.sync="dialogVisibleTeacherImport">
      <el-upload
        class="image-uploader"
        :multiple="false"
        :auto-upload="true"
        list-type="excel"
        :show-file-list="true"
        :drag="true"
        action
        :limit="1"
        :on-exceed="handleExceed"
        :before-upload="beforeUpload"
        :http-request="upadeUploadFile"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          将文件拖到此处，或
          <em>点击上传</em>
        </div>
        <div class="el-upload__tip" slot="tip">
          一次只能上传一个文件，仅限excel格式，单文件不超过5MB
        </div>
      </el-upload>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleTeacherImport = false">取消</el-button>
        <el-button type="primary" @click="onClickUpadeImport">提交</el-button>
      </div>
    </el-dialog>
    <!-- 查看账号 -->
    <el-dialog title="查看账号" :visible.sync="dialogVisibleBound" width="30%">
      <div>
        <el-table :data="BoundData" style="width: 100%">
          <el-table-column prop="userName" label="昵称"> </el-table-column>
          <el-table-column prop="code" label="账号"> </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="primary" @click="onClickBingd(scope.row)">{{
                scope.row.userId == 0 ? "绑定" : "重新绑定"
              }}</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 内层 -->
        <el-dialog
          width="30%"
          title="关联账号"
          :visible.sync="innerVisible"
          append-to-body
        >
          <div>
            <el-row class="flex">
              <el-col style="margin-right: 20px">
                <el-input
                  v-model="RealName"
                  placeholder="请输入昵称"
                ></el-input>
              </el-col>
              <el-col style="margin-right: 20px">
                <el-input
                  v-model="LoginName"
                  placeholder="请输入账号"
                ></el-input>
              </el-col>
              <el-col>
                <el-button type="primary" @click="GetUserBandList"
                  >查询</el-button
                >
              </el-col>
            </el-row>
            <el-table :data="relevanceData" style="width: 100%">
              <el-table-column prop="userName" label="昵称"> </el-table-column>
              <el-table-column prop="code" label="账号"> </el-table-column>
              <el-table-column prop="schoolName" label="所属幼儿园">
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button
                    type="primary"
                    @click="onClickSearchBingd(scope.row)"
                    >{{
                      scope.row.userId == 0 ? "绑定" : "重新绑定"
                    }}</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-dialog>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleBound = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleBound = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="教师权限修改"
      :visible.sync="editFormVisibleRoleclass"
      width="30%"
    >
      <el-tree
        :data="data"
        show-checkbox
        node-key="Id"
        :props="defaultProps"
        ref="tree"
        :default-checked-keys="checked"
        :check-strictly="true"
        :default-expand-all="true"
      >
      </el-tree>

      <span slot="footer" class="dialog-footer">
        <el-button @click="editFormVisibleRoleclass = false">取 消</el-button>
        <el-button type="primary" @click="onEditPreserve">保存</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import {
  GetTeacherInfo,
  removeUser,
  DelTeacherInfo,
  Updatef_teacherinfo,
  Addf_teacherinfo,
  ResetUserPwd,
  AddUserClassRole,
  ImportTeacherinfo,
  FileUploadsExcel,
  GetSchoolList,
  GetTeacher2User,
  GetUserBandList,
  BandUser,
  GetClassRole,
  ImportUpdateTeacherRole,
} from "../../api/api";
// import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      dialogVisibleImport: false,
      defaultProps: {
        children: "Children",
        label: "Label",
        Id: "Id",
      },
      data: [], //树的数据
      checked: [], //默认选中项

      teacherId: 0,

      searchnames: "",
      showteacherrole: false,
      newpwd: "",
      dialogVisibleresetpwd: false,
      filters: {
        name: "",
      },
      users: [],
      roles: [],
      total: 0,
      buttonList: [],
      currentRow: null,
      PageIndex: 1,
      PageSize: 10,
      listLoading: false,
      sels: [], //列表选中列
      editFormVisibleRoleclass: false,
      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        Phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        SchoolName: [
          { required: true, message: "请选择幼儿园", trigger: "change" },
        ],
      },
      //编辑界面数据
      editForm: {
        id: 0,
        name: "",
        uLoginName: "",
        uRealName: "",
        resource: 0,
        sex: 1,
        Phone: "",
        SchoolName: "",
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        Phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        SchoolName: [
          { required: true, message: "请选择幼儿园", trigger: "change" },
        ],
      },
      //新增界面数据
      addForm: {
        name: "",
        uLoginName: "",
        uRealName: "",
        resource: 0,
        sex: 1,
        Phone: "",
        SchoolName: "",
      },
      userInfo: {},
      SchoolList: [],
      SchoolName: null,
      addSchoolList: [],
      dialogVisibleBound: false,
      innerVisible: false,
      BoundData: [],
      RealName: "",
      LoginName: "",
      relevanceData: [],
      listId: 0,
      excelurl: "",
      teacherId: 0,
      data: [], //树的数据
      checked: [], //默认选中项
      editFormVisibleRoleclass: false,
      Phone: "",
      dialogVisibleTeacherImport: false,
      uploadExcelurl: "",
    };
  },
  methods: {
    onStudentExeal() {
      location.href =
        "http://www.mushroomisland.cn/exceldown/蘑菇岛V3教师导入模板.xlsx";
    },
    onEditPreserve() {
      let pids = this.$refs.tree.getCheckedKeys();
      var tree = this.data;
      let infos = [];
      tree.forEach((x) => {
        //学届
        x.Children.forEach((y) => {
          //年级
          let yChildren = y.Children;
          for (let z = 0; z < yChildren.length; z++) {
            //班级
            let zid = yChildren[z].Id;
            if (pids.indexOf(zid) != -1) {
              //存在
              infos.push({
                StudyYearId: x.RealId,
                GradeId: y.RealId,
                ClassId: yChildren[z].RealId,
              });
            }
          }
        });
      });
      //console.log(this.userInfo);
      let para = {
        SysUserId: this.teacherId,
        SchoolId: this.userInfo.SchoolId,
        infos: infos,
      };
      AddUserClassRole(para).then((res) => {
        if (res.data.success) {
          this.editFormVisibleRoleclass = false;
          this.data = [];
          this.$message({
            type: "success",
            message: "分配成功",
          });
        }
      });
    },
    async onClickSearchBingd(item) {
      let res = await BandUser({ Id: this.listId, userId: item.userId });
      if (res.data.success) {
        this.innerVisible = false;
        this.dialogVisibleBound = false;
        this.$message({
          type: "success",
          message: res.data.msg,
        });
      } else {
        this.innerVisible = false;
        this.dialogVisibleBound = false;
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    async onClickBingd(item) {
      this.innerVisible = true;
    },
    async GetUserBandList() {
      let res = await GetUserBandList({
        LoginName: this.LoginName,
        RealName: this.RealName,
      });
      if (res.data.success) {
        this.relevanceData = res.data.response;
      } else {
        this.relevanceData = [];
      }
    },
    //   查看关联
    async onClickOpen(item) {
      this.BoundData = [];
      this.listId = item.Id;
      let res = await GetTeacher2User({ Id: item.Id });
      if (res.data.success) {
        this.BoundData.push(res.data.response);
        this.dialogVisibleBound = true;
      } else {
        this.BoundData.push({
          code: "",
          userName: "",
          userId: 0,
          schoolName: null,
        });
        this.dialogVisibleBound = true;
      }
    },
    async addonScrollData() {
      let res = await GetSchoolList();
      if (res.data.success) {
        this.addSchoolList = res.data.response;
      }
    },
    async onScrollData() {
      let res = await GetSchoolList();
      if (res.data.success) {
        this.SchoolList = res.data.response;
      }
    },
    onChangeScrollData(e) {
      this.SchoolName = e;
      this.getUsers();
    },
    handleClick(tab, event) {
      //console.log(tab, event);
    },
    // 更新导师权限
    upadeUploadFile(item) {
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      //    form.append("comId", this.comId);
      form.append("filetype", "excel");
      // //console.log(form);
      //debugger;
      FileUploadsExcel(form).then((res) => {
        this.uploadExcelurl = res.data.response;
        // //console.log(response);
        // //console.log(this.excelurl);
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    //导入教师
    uploadFile(item) {
      //console.log(item);
      //    //console.log(this.comId);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      //    form.append("comId", this.comId);
      form.append("filetype", "excel");
      // //console.log(form);
      //debugger;
      FileUploadsExcel(form).then((res) => {
        this.excelurl = res.data.response;
        // //console.log(response);
        // //console.log(this.excelurl);
        this.$message.info("文件：" + fileObj.name + "上传成功");
      });
    },
    // 更新教师权限
    onClickUpadeImport() {
      if (this.uploadExcelurl) {
        ImportUpdateTeacherRole({
          fileName: this.uploadExcelurl,
          Uid: this.userInfo.uID,
          SchoolId: this.userInfo.SchoolId,
          UserName: this.userInfo.uRealName,
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: "成功",
              type: "success",
            });
            //初始化数据
            this.dialogVisibleTeacherImport = false;
            this.getUsers();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: "请选择文件",
          type: "error",
        });
      }
    },
    //上传文件
    ImportTeacherinfo() {
      if (this.excelurl) {
        ImportTeacherinfo({
          fileName: this.excelurl,
          Uid: this.userInfo.uID,
          SchoolId: this.userInfo.SchoolId,
          UserName: this.userInfo.uRealName,
        }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: "成功",
              type: "success",
            });
            //初始化数据
            this.dialogVisibleImport = false;
            this.getUsers();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      } else {
        this.$message({
          message: "请选择文件",
          type: "error",
        });
      }
    },
    // 上传文件个数超过定义的数量
    handleExceed() {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    beforeUpload(file) {
      //console.log("beforeUpload");
      // //console.log(file.type);
      const isText = file.type === "application/vnd.ms-excel";
      const isTextComputer =
        file.type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      return isText | isTextComputer;
    },
    search() {},
    //导入教师
    ImportTeacher() {
      //上传文件  保存
    },
    selectCurrentRow(val) {
      console.log(val);
      this.currentRow = val;
    },
    // callFunction(item) {
    //   this.filters = {
    //     name: item.search,
    //   };
    //   this[item.Func].apply(this, item);
    // },
    //性别显示转换
    formatSex: function (row, column) {
      return row.sex == 1 ? "男" : row.sex == 0 ? "女" : "未知";
    },
    formatBirth: function (row, column) {
      return !row.birth || row.birth == ""
        ? ""
        : util.formatDate.format(new Date(row.birth), "yyyy-MM-dd");
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.getUsers();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.getUsers();
    },
    //显示权限分配界面
    OpenTeacherRole(index, row) {
      //console.log(row);
      let para = {
        SchoolId: row.SchoolId,
        SysUserId: row.UserId,
      };
      GetClassRole(para).then((res) => {
        this.teacherId = row.UserId;
        if (res.data.success) {
          this.data = res.data.response.Children;

          var tree = this.data;
          let checked = [];
          tree.forEach((x) => {
            //学届
            if (x.Checked == true) {
              checked.push(x.Id);
            }
            x.Children.forEach((y) => {
              //年级
              if (y.Checked == true) {
                checked.push(y.Id);
              }
              let yChildren = y.Children;
              for (let z = 0; z < yChildren.length; z++) {
                //班级
                if (yChildren[z].Checked == true) {
                  checked.push(yChildren[z].Id);
                }
              }
            });
          });
          this.checked = checked;
          //console.log(this.checked);
          this.editFormVisibleRoleclass = true;
        }
      });
    },
    //显示重置密码界面
    OpenResetPwd() {
      if (this.sels == null || this.sels.length <= 0) {
        this.$message({
          message: "请选择用户！",
          type: "error",
        });
        return;
      }
      this.dialogVisibleresetpwd = true;
    },
    //重置密码
    ResetPwd() {
      var ids = this.sels.map((x) => x.UserId);
      if (ids.length <= 0) {
        this.$message({
          message: "请选择有效用户",
          type: "error",
        });
        return;
      }
      ResetUserPwd({ Ids: ids, PassWord: this.newpwd }).then((res) => {
        if (res.data.success) {
          this.$message({
            message: res.data.msg,
            type: "success",
          });
          this.dialogVisibleresetpwd = false;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },
    DelTeacherInfo() {
      var ids = this.sels.map((x) => x.Id);
      if (ids.length <= 0) {
        this.$message({
          message: "请选择有效用户",
          type: "error",
        });
        return;
      }
      this.$confirm("确认删除这些用户吗?", "提示", {
        type: "warning",
      }).then(() => {
        DelTeacherInfo({ Ids: ids }).then((res) => {
          if (res.data.success) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
            this.getUsers();
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        });
      });
    },
    //获取用户列表
    getUsers() {
      let para = {
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: this.searchnames,
        Phone: this.Phone,
        SchoolId:
          this.userInfo.uID == 12 ? this.SchoolName : this.userInfo.SchoolId,
      };
      this.listLoading = true;

      //NProgress.start();
      GetTeacherInfo(para).then((res) => {
        if (res.data.success) {
          this.total = res.data.response.dataCount;
          this.users = res.data.response.data;
          this.listLoading = false;
        } else {
          this.total = 0;
          this.users = [];
        }
        //NProgress.done();
      });
    },
    //删除
    handleDel(index, row) {
      if (!row) {
        this.$message({
          message: "请选择要删除的一行数据！",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { id: row.uID };
          removeUser(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getUsers();
          });
        })
        .catch(() => {});
    },
    handleEditInfo(index, row) {
      this.$router.push({
        path: "/User/UsersDeite",
        query: { Code: row.uLoginName, isSchool: false },
      });
    },
    //显示编辑界面
    handleEdit(index, row) {
      //let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.editFormVisible = true;
      if (this.userInfo.uID == 12) {
        this.addonScrollData();
      }
      this.editForm = {
        id: row.Id,
        name: row.TeacherName,
        resource: row.IsHeader === false ? 0 : 1,
        sex: row.Sex,
        Phone: row.Phone,
        SchoolName: row.SchoolId,
      };
      //console.log(this.editForm, "this.editForm");
      //console.log(row);
      //   getRoleListPage({ uid: this.userInfo.uID }).then((res) => {
      //     this.roles = res.data.response.data;
      //   });
    },
    //显示新增界面
    handleAdd() {
      this.addFormVisible = true;
      this.addForm = {
        name: "",
        uLoginName: "",
        uRealName: "",
        resource: 0,
        sex: 1,
        Phone: "",
        SchoolName: null,
      };
    },
    //编辑
    editSubmit: function () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.editLoading = true;
            //NProgress.start();
            // let para = Object.assign({}, this.editForm);

            // para.birth =
            //   !para.birth || para.birth == ""
            //     ? util.formatDate.format(new Date(), "yyyy-MM-dd")
            //     : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");
            let params = {
              TeacherName: this.editForm.name,
              Sex: this.editForm.sex,
              Phone: this.editForm.Phone,
              SchoolId: this.editForm.SchoolName,
              IsHeader: this.editForm.resource,
              id: this.editForm.id,
            };

            Updatef_teacherinfo(params).then((res) => {
              if (util.isEmt.format(res)) {
                this.editLoading = false;
                return;
              }
              if (res.data.success) {
                this.editLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["editForm"].resetFields();
                this.editFormVisible = false;
                this.getUsers();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    //新增
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            // let para = Object.assign({}, this.addForm);
            // para.birth =
            //   !para.birth || para.birth == ""
            //     ? util.formatDate.format(new Date(), "yyyy-MM-dd")
            //     : util.formatDate.format(new Date(para.birth), "yyyy-MM-dd");
            let params = {
              TeacherName: this.addForm.name,
              Sex: this.addForm.sex,
              Phone: this.addForm.Phone,
              SchoolId:
                this.userInfo.uID == 12
                  ? this.addForm.SchoolName
                  : this.userInfo.SchoolId,
              IsHeader: this.addForm.resource,
              SchoolType: 3,
            };
            Addf_teacherinfo(params).then((res) => {
              if (util.isEmt.format(res)) {
                this.addLoading = false;
                return;
              }

              if (res.data.success) {
                this.addLoading = false;
                //NProgress.done();
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.$refs["addForm"].resetFields();
                this.addFormVisible = false;
                this.getUsers();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //批量删除
    batchRemove: function () {
      // return;

      var ids = this.sels.map((item) => item.Id).toString();
      console.log(ids);
      this.$confirm("确认删除选中记录吗？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = { ids: ids };

          batchRemoveUser(para).then((res) => {
            this.listLoading = false;
            //NProgress.done();
            this.$message({
              message: "该功能未开放",
              type: "warning",
            });
            //console.log(res);
          });
        })
        .catch(() => {});
    },
  },
  created() {
    this.userInfo = JSON.parse(window.localStorage.user);
    if (this.userInfo.SchoolId != 0 && this.userInfo.UserType == 7) {
      this.showteacherrole = true;
    }
  },
  mounted() {
    this.getUsers();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    // this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.btn-add {
  width: 100px;
  height: 30px;
  background: #ff8503;
  border-radius: 3px;
  color: #fff;
  font-size: 14px;
  margin: 0 20px;
}
.btn-delete {
  width: 100px;
  height: 30px;
  background: #ff0000;
  border-radius: 3px;
  color: #fff;
  font-size: 14px;
  margin: 0 20px;
}
.tui-edit {
  color: #3d98ee;
  font-size: 14px;
  cursor: pointer;
}
.tui-delete {
  color: #f14545;
  font-size: 14px;
}
</style>